export function uppercase(val) {
  if (!val) {
    return ''
  }
  const value = val.toString()
  return value.toUpperCase()
}
